import { notification } from 'antd';
// import LockAnimation from "../utils/unlock.jsx"
const Notifications = ({ placement, message, description, showProgress }) => {

  const key = `open${Date.now()}`; // Unique key to avoid duplicate notifications
  
  notification.info({
    message,
    description,
    placement,
    key,
    // showProgress, 
    // icon:(<div style={{paddingBottom: '128px'}}><LockAnimation status="success" /></div>),
    onClick: () => {
      console.log('Notification Clicked!');
    },
  });
};

export default Notifications;
